import { t } from 'ttag'

import { BLACK, SO, SO90T } from '@h2/components/colors'
import { LibrarianIcon } from '@h2/components/icons/librarian'
import guideSvg from '@h2/assets/svg/illustrations/upTheLadder/earlyLearnersCtaUserGuide.svg'

import { Cta } from './common/cta'

const MyWork = () => {
  return (
  <>
    <Cta bgColor={SO90T} borderColor={SO} bgImage={guideSvg}>
      <Cta.Heading color={BLACK}>{t`My Work`}</Cta.Heading>
      <Cta.Link href="/planning/assignments" icon={LibrarianIcon} align="left">
        {t`Review`}
      </Cta.Link>
    </Cta>
  </>
  )
}

export { MyWork }
